import React from 'react';
import PropTypes from 'prop-types';
import { Modal } from 'antd';
import { useTranslation } from 'react-i18next';
import ErasmusApplicationEdit from '../ErasmusApplicationEdit/ErasmusApplicationEdit.jsx';

const MobilityModal = ({
  visible,
  toggleModal,
  title,
  id, // Obsahuje všetky údaje mobility
}) => {
  const { t } = useTranslation();

  return (
    <Modal
      open={visible}
      title={title || t('Detail mobility')}
      onCancel={toggleModal}
      footer={null}
      width={1000}
    >
      <ErasmusApplicationEdit
        mode={'preview'}
        id={id}
      />
    </Modal>
  );
};

MobilityModal.propTypes = {
  visible: PropTypes.bool,
  toggleModal: PropTypes.func,
  title: PropTypes.string,
  id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
};

export default MobilityModal;
